/* global XMLHttpRequest */
import appConfig from 'app/config/client';

export default function sendPayloadToHoneybadger(payloadString, { onError, onSuccess }) {
  try {
    const request = new XMLHttpRequest();
    // The Honeybadger API says to use `/v1/notices`, but that returns an `Invalid API Key` warning.
    request.open('POST', 'https://api.honeybadger.io/v1/notices/js', true);
    request.setRequestHeader('X-API-Key', appConfig.honeybadger.apiKey);
    request.setRequestHeader('Content-Type', 'application/json');
    request.setRequestHeader('Accept', 'text/json, application/json');
    request.addEventListener('error', () => {
      onError(new Error('Honeybadger error payload failed to send.'));
    });
    request.addEventListener('load', () => {
      if (request.status !== 201) {
        onError && onError(new Error(
          `Expected 201 response from Honeybadger, but got ${request.status} status.`,
        ));
      } else {
        onSuccess && onSuccess();
      }
    });
    request.send(payloadString);
  } catch (e) {
    // If sending the payload fails at the last step, don't throw an error, or else it could be
    // caught be the global onerror handler and we could cause an infinite loop.
    onError && onError(e);
  }
}
